console.log('[emb-fee] v4 loaded');
(function () {
  var FEE = 52421619515675;
  var TAG = 'embroidery';
  var cache = {};
  var busy = false;
  var f = window.fetch;

  function tags(h) {
    if (cache[h]) return Promise.resolve(cache[h]);
    return f('/products/' + h + '.js').then(function (r) { return r.json(); })
      .then(function (p) { cache[h] = (p.tags || []).map(function (t) { return ('' + t).toLowerCase(); }); return cache[h]; })
      .catch(function () { cache[h] = []; return []; });
  }

  function hasEmb(cart) {
    var hs = [];
    cart.items.forEach(function (i) { if (i.variant_id !== FEE && hs.indexOf(i.handle) < 0) hs.push(i.handle); });
    var k = 0;
    function step() {
      if (k >= hs.length) return Promise.resolve(false);
      return tags(hs[k++]).then(function (t) { return t.indexOf(TAG) >= 0 ? true : step(); });
    }
    return step();
  }

  function post(url, body) {
    return f(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  }

  function sync(afterAdd) {
    if (busy) return;
    busy = true;
    var changed = false;
    f('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      return hasEmb(cart).then(function (emb) {
        var line = cart.items.find(function (i) { return i.variant_id === FEE; });
        if (emb && !line) { changed = true; return post('/cart/add.js', { items: [{ id: FEE, quantity: 1 }] }); }
        if (emb && line && line.quantity !== 1) { changed = true; return post('/cart/change.js', { id: '' + FEE, quantity: 1 }); }
        if (!emb && line) { changed = true; return post('/cart/change.js', { id: '' + FEE, quantity: 0 }); }
      });
    }).catch(function (e) { console.warn('[emb-fee] err', e); }).then(function () {
      busy = false;
      if (changed && afterAdd) { window.location.href = '/cart'; }
      else if (changed) {
        var n = +(sessionStorage.getItem('embR') || 0);
        if (n < 3) { sessionStorage.setItem('embR', n + 1); window.location.reload(); }
      } else { sessionStorage.removeItem('embR'); }
    });
  }

  function note() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    tags(m[1]).then(function (t) {
      if (t.indexOf(TAG) < 0) { console.log('[emb-fee] no tag here'); return; }
      var n = 0;
      var iv = setInterval(function () {
        if (document.getElementById('emb-note')) { clearInterval(iv); return; }
        var form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('product-form');
        if (form) {
          var d = document.createElement('div');
          d.id = 'emb-note';
          d.style.cssText = 'margin:12px 0;padding:10px 12px;border:1px solid #ddd;border-radius:6px;background:#faf7f2;font-size:14px;';
          d.innerHTML = 'This item includes a <strong>$10 embroidery fee</strong>, added automatically to your cart (once per order).';
          (form.parentNode || form).insertBefore(d, form);
          console.log('[emb-fee] note added');
          clearInterval(iv);
        }
        if (++n > 25) { console.log('[emb-fee] form not found'); clearInterval(iv); }
      }, 200);
    });
  }

  function kind(u) {
    if (typeof u !== 'string' || u.indexOf('cart.js') >= 0) return null;
    if (/\/cart\/add/.test(u)) return 'add';
    if (/\/cart\/(change|update)/.test(u)) return 'change';
    return null;
  }

  window.fetch = function () {
    var a = arguments;
    var u = (a[0] && a[0].url) || a[0] || '';
    var k = kind(u);
    var p = f.apply(this, a);
    if (k && !busy) p.then(function () { setTimeout(function () { sync(k === 'add'); }, 300); });
    return p;
  };

  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this._u = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var k = kind(this._u);
    if (k && !busy) this.addEventListener('load', function () { setTimeout(function () { sync(k === 'add'); }, 300); });
    return xs.apply(this, arguments);
  };

  document.addEventListener('DOMContentLoaded', function () { note(); sync(false); });
})();